/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/label-has-associated-control, import/no-cycle  */
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types";
import React from "react";

import EmbeddedLink from "./EmbeddedLink";
import { AssetLink, EntryLink } from "./InlineLinks";

const idAttributeFromNodeContent = (contentfulRichTextNode: any) => {
  const textContent = contentfulRichTextNode.content
    .filter((content: any) => content.nodeType === "text")
    .map((content: any) => content.value)
    .join(" ");

  const normalizedText = textContent
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  const generatedSlug = normalizedText
    .replace(/([^a-z\d]+)/g, "-")
    .replace(/(^-|-$)/, "");

  return { id: generatedSlug };
};

interface Props {
  data?: any;
  renderMark?: any;
  renderNode?: any | Promise<Response>;
  theme?: any;
  isInverted?: any;
}

const RichText = (props: Props) => {
  const { data, renderMark, renderNode, theme, isInverted } = props;

  return (
    <>
      {data &&
        documentToReactComponents(data.json, {
          renderMark: {
            [MARKS.ITALIC]: (text: any) => (
              <span className={`text_highlight text_highlight--${theme}`}>
                <span>{text}</span>
              </span>
            ),
            ...renderMark,
          },
          renderNode: {
            [INLINES.EMBEDDED_ENTRY]: (node: any) => {
              switch (node.data.target.sys.contentType.sys.id) {
                case "link":
                  return (
                    <EmbeddedLink
                      isInverted={isInverted}
                      data={node.data.target.fields}
                      className=""
                      a11yText=""
                    />
                  );
                default:
                  return null;
              }
            },
            [BLOCKS.HEADING_1]: (_node: any, children: any) => (
              <h2 className="h1" {...idAttributeFromNodeContent(_node)}>
                {children}
              </h2>
            ),
            [BLOCKS.HEADING_2]: (_node: any, children: any) => (
              <h2 {...idAttributeFromNodeContent(_node)}>{children}</h2>
            ),
            [BLOCKS.HEADING_3]: (_node: any, children: any) => (
              <h3 {...idAttributeFromNodeContent(_node)}>{children}</h3>
            ),
            [BLOCKS.HEADING_4]: (_node: any, children: any) => (
              <h4 {...idAttributeFromNodeContent(_node)}>{children}</h4>
            ),
            [BLOCKS.HEADING_5]: (_node: any, children: any) => (
              <h5 {...idAttributeFromNodeContent(_node)}>{children}</h5>
            ),
            [BLOCKS.HEADING_6]: (_node: any, children: any) => (
              <p className="paragraph_intro">{children}</p>
            ),
            [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
              return (
                <img src={node.data.target.fields.file["en-NZ"].url} alt="" />
              );
            },
            [BLOCKS.EMBEDDED_ENTRY]: (node: any) => {
              switch (node.data.target.sys.contentType.sys.id) {
                default:
                  return null;
              }
            },
            [BLOCKS.QUOTE]: (node: any, children: any) => (
              <blockquote className="blockquote">{children}</blockquote>
            ),
            [INLINES.ASSET_HYPERLINK]: (node: any) => {
              return (
                <AssetLink
                  isInverted={isInverted}
                  linkTitle={node.content[0].value}
                  asset={node.data.target.fields}
                />
              );
            },
            [INLINES.ENTRY_HYPERLINK]: (node: any) => (
              <EntryLink node={node} isInverted={isInverted} />
            ),
            [INLINES.HYPERLINK]: (node: any, children: any) => (
              <a
                href={node.data.uri}
                className={isInverted ? "link link_dark" : "link"}
              >
                {children}
              </a>
            ),
            ...renderNode,
          },
          renderText: (text: any) => {
            return text
              .split("\n")
              .reduce((children: any, textSegment: any, index: any) => {
                return [...children, index > 0 && <br />, textSegment];
              }, []);
          },
        })}
    </>
  );
};

export default RichText;
